import React from "react";
import {ListEditor} from "../../components/list-editor";
import * as yup from "yup";
import {Tooltip} from "@mui/material";
import {useLocation} from "react-router";
import {FieldTableTitleTooltip} from "../../components/FieldTable/FieldTableTitleTooltip";
import {uniqueId} from "../../utils";
import { CampaignTag, CampaignTagsQuery, useUpdateCampaignTagsMutation, useCampaignTagsFullQuery } from "../../generated/graphql";


const columns = [{
    header: 'Section',
    accessor: 'section_code',
    dataType:'text',
}, {
    header: 'Name',
    accessor: 'name',
    dataType:'text',
}, {
    header: 'Description',
    accessor: 'description',
    dataType:'text',
}, {
    headerRaw:'Code',
    header: <Tooltip title="Used to identify tags on the server"><FieldTableTitleTooltip>Daybook code</FieldTableTitleTooltip></Tooltip>,
    accessor: 'code',
    dataType:'text',
}
];

function newRow():CampaignTag {
    return {
        id: uniqueId(),
        name: '',
        section_code: '',
        code: '',
        description:''
    }
}

const schema =  yup.array().of(
                yup.object().shape({
                    'section_code': yup.string().required(),
                    'name': yup.string().required()
                })
);

function getValues(data:CampaignTagsQuery):CampaignTag[] {
    return data?.campaignTags?.data??[];
}

const CampaignTags = ()=> {
    const url = useLocation().pathname;
    const query = useCampaignTagsFullQuery();
    const [mutation,mutationResult] = useUpdateCampaignTagsMutation();

    return (
        <ListEditor
           columns={columns}
           validationSchema={schema}
            title="Campaign Tags"
            permission="campaigntags"
            query={query}
           saveResult={mutationResult}
           getValues={getValues}
           baseUrl={url}
           className="campaign-tags"
            newRow={newRow}
            newRowLabel="Add Campaign Tag"
         mutation={mutation}
        />);
}

export default CampaignTags;
